import ApplicationLoader from "@/ApplicationLoader";

import VotingContainer from "./VotingContainer";

const AppLoader = new ApplicationLoader(VotingContainer);

AppLoader.start();
